<template>
  <v-container grid-list-xs>
    <v-row>
      <v-col v-if="isEditing" cols="12">
        <div class="text-h5">
          {{ $$t('editHeading') }}
        </div>
      </v-col>
      <v-col v-else cols="12">
        <div class="text-h5">
          {{ $$t('heading') }}
        </div>
      </v-col>
      <v-col cols="12">
        <ImageUpload
          data-cy="EditArticle-photo-image-upload"
          v-model="article.photo"
          :label="$$t('photo')" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          data-cy="EditArticle-titleAf"
          label="Titel (Afrikaans)"
          v-model="article.titleAf"
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          data-cy="EditArticle-titleEn"
          label="Title (English)"
          v-model="article.titleEn"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-text-field
          data-cy="EditArticle-subTitleAf"
          label="Sub Titel (Afrikaans)"
          v-model="article.subTitleAf"
        />
      </v-col>
      <v-col cols="6">
        <v-text-field
          data-cy="EditArticle-subTitleEn"
          label="Sub Title (English)"
          v-model="article.subTitleEn"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        Afrikaans
        <vue-editor v-model="article.bodyAf"
          data-cy="EditArticle-bodyAf" />
      </v-col>
      <v-col cols="6">
        English
        <vue-editor v-model="article.bodyEn"
          data-cy="EditArticle-bodyEn" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-checkbox
          data-cy="EditArticle-isActive"
          :label="$$t('isActive')"
          v-model="article.isActive"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-btn color="success" @click="save" :loading="isSaving"
          data-cy="EditArticle-title">
          {{ $t('common.buttons.save') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import { VueEditor } from 'vue2-editor';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'EditArticle',
  module: 'Membership',
  components: { VueEditor },
  mixins: [loading],
  data() {
    return {
      isEditing: false,
      id: this.$route.query.id,
      article: {
        titleAf: '',
        titleEn: '',
        subTitleAf: '',
        subTitleEn: '',
        bodyAf: '',
        bodyEn: '',
      },
    };
  },
  async mounted() {
    if (this.id) {
      this.isEditing = true;
      this.isLoading = true;
      this.article = await this.LOAD_article(this.id);
      this.isLoading = false;
    } else {
      this.isEditing = false;
    }
  },
  methods: {
    ...mapActions('articles', ['CREATE_article', 'LOAD_article', 'UPDATE_article']),
    async save() {
      this.isSaving = true;
      if (this.isEditing) {
        await this.UPDATE_article(this.article);
      } else {
        await this.CREATE_article(this.article);
      }
      this.isSaving = false;
      this.$router.push({ name: 'membership-ListArticles' });
    },
  },
};
</script>

<style lang="css">
@import "~vue2-editor/dist/vue2-editor.css";
</style>
